import type {
  DropdownBase,
} from '../Dropdown';

import { Menu } from './Menu';
import type {
  DropdownMenuItemType,
} from './types';

export const createDropdownMenu = (
  menu: DropdownMenuItemType[],
): DropdownBase => ({
  renderContent: ({
    close,
  }) => (
    <Menu
      close={close}
      menu={menu}
    />
  ),
});
